import bcrypt from "bcryptjs";

const userReducer = (
  state = {
    name_surname: "",
    email: "",
    phone: "",
    password: "",
    address: {
      label: "",
      city: "",
      postcode: "",
      street: "",
      housenumber: "",
      context: "",
      x: "",
      y: "",
    },
  },
  action
) => {
  if (action.type === "NEXT") {
    let password = document.getElementById("Password").value;
    const saltRounds = 10;
    const hash = bcrypt.hashSync(password, saltRounds);

    let name_surname = document.getElementById("name_surname").value.trim();
    let email = document.getElementById("email").value;
    let phone = document.getElementById("phone").value;
    return { ...state, name_surname, email, phone, hash };
  }
  if (action.type === "HANDLECHANGE") {
    console.log(action.payload.location);

    let label = action.payload.location.label;
    let city = action.payload.location.city;
    let postcode = action.payload.location.postcode;
    let street = action.payload.location.street;
    let housenumber = action.payload.location.housenumber;
    let context = action.payload.location.context;
    let x = action.payload.location.x;
    let y = action.payload.location.y;

    return {
      ...state,
      address: {
        ...state.address,
        label,
        city,
        postcode,
        street,
        housenumber,
        context,
        x,
        y,
      },
    };
  } else {
    return state;
  }
};

export default userReducer;
